<template>
  <transition name="slide">
    <div class="nav-left-mobile" :style="{ height: height + 'px' }" v-show="isMenuOpen"
      :class="isMenuOpen ? 'open' : 'close'">
      <el-menu class="el-menu-vertical-demo left-bar" :unique-opened="true" :collapse="false"
        :default-openeds="activeMenu" :default-active="activeApp" :style="{ height: height + 'px' }">


        <el-submenu v-for="(area, index) in menu" :key="index" :index="area.area" v-if="area.mobile === 'S'"
          :class="[area.iconMobile === undefined ? 'no-icon' : '']">
          <template slot="title">
            <div v-if="area.tipologia !== 'url'" class="titolo"
              @click="area.tipologia === 'rotta' ? goToArea(area, area.area) : ''">
              <icon v-if="area.iconMobile !== undefined" :name="area.iconMobile" scale="1.5" class="icon"></icon>
              <div slot="title" class="my-label">{{ getLabel(area).toUpperCase() }}</div>
            </div>
          </template>
          <div v-for="(item, index) in area.apps" :key="index">
            <el-menu-item :index="item.codiApp" v-if="item.mobile === 'S'">
              <div v-if="item.hasOwnProperty('url')" class="label-menu">
                <a target="_blank" :href="item.url">
                  <div class="applicazione">{{ item.titolo }}</div>
                </a>
              </div>
              <div v-else class="label-menu" @click="goToApp(item, area.area)">
                <img class="cerchio" src="static/img/cerchio.png">
                <div class="applicazione">{{ getLabel(item) }}</div>
              </div>
            </el-menu-item>
          </div>

        </el-submenu>



        <div class="servizi">
          <div class="linea"></div>
          <el-submenu index="95" v-if="checkInfo">
            <template slot="title">
              <div class="titolo" @click="goToRout('Informativa')">
                <icon name="riv-help" scale="1.5" class="icon"></icon>
                <div slot="title" class="my-label">{{ $t('info') }}</div>
              </div>
            </template>
          </el-submenu>
          <el-submenu index="96">
            <template slot="title">
              <div class="titolo" @click="goToRout('profilo')">
                <icon name="riv-user" scale="1.5" class="icon"></icon>
                <div slot="title" class="my-label">{{ $t('profilo') }}</div>
              </div>
            </template>
          </el-submenu>
          <el-submenu index="97">
            <template slot="title">
              <div class="titolo" @click="goToRout('messaggi')">
                <icon name="riv-voice" scale="1.5" class="icon"></icon>
                <div slot="title" class="my-label">{{ $t('com') }}</div>
              </div>
            </template>
          </el-submenu>
          <el-submenu index="98">
            <template slot="title">
              <div class="titolo" @click="goToRout('links')">
                <icon name="riv-linkPort" scale="1.5" class="icon"></icon>
                <div slot="title" class="my-label">{{ $t('links') }}</div>
              </div>
            </template>
          </el-submenu>
          <el-submenu index="99">
            <template slot="title">
              <div class="titolo" @click="logout()">
                <icon name="riv-uscitaStab" scale="1.5" class="icon"></icon>
                <div slot="title" class="my-label">{{ $t('logout') }}</div>
              </div>
            </template>
          </el-submenu>
        </div>
      </el-menu>
    </div>
  </transition>

</template>

<script>
export default {
  name: 'NavLeft',
  i18n: {
    messages: {
      it_IT: {
        logout: 'Logout',
        links: 'Link utili',
        com: 'Comunicazioni',
        info: 'Informativa',
        profilo: 'Profilo Personale',
        subMenu: {
          ASSENZE: 'Assenze',
          TRASFERTE: 'Trasferte',
          PRESENZE: 'Presenze',
          DELSIND: 'Deleghe Sindacali'
        }

      },
      fr_FR: {
        logout: 'Logout',
        links: 'Liens utiles',
        com: 'Communications',
        info: 'Informativa',
        profilo: 'Données de profil',
        subMenu: {
          ASSENZE: 'Absences',
          TRASFERTE: 'Déplacements',
          PRESENZE: 'Présence',
          DELSIND: 'Deleghe Sindacali'
        }
      },
      es_ES: {
        logout: 'Logout',
        links: 'Enlaces útiles',
        com: 'Comunicación',
        info: 'Informativa',
        profilo: 'Datos de perfil',
        subMenu: {
          ASSENZE: 'Ausencia',
          TRASFERTE: 'Viaje',
          PRESENZE: 'Presencias',
          DELSIND: 'Deleghe Sindacali'
        }
      },
      de_DE: {
        logout: 'Logout',
        links: 'Nützliche Links',
        com: 'Kommunikation',
        info: 'Informativa',
        profilo: 'Profildaten',
        subMenu: {
          ASSENZE: 'Freizeit',
          TRASFERTE: 'Dienstreise',
          PRESENZE: 'AN- / Abwesenheiten',
          DELSIND: 'Deleghe Sindacali'
        }
      },
      en_GB: {
        logout: 'Logout',
        links: 'Useful Links',
        com: 'Communications',
        info: 'Informativa',
        profilo: 'Profile data',
        subMenu: {
          ASSENZE: 'Absence',
          TRASFERTE: 'Business trips',
          PRESENZE: 'Attendance report',
          DELSIND: 'Deleghe Sindacali'
        }

      }
    }
  },
  props: {
    height: {
      type: Number,
      required: true,
      default: 650
    },
    isMenuOpen: {
      type: Boolean
    }
  },
  data() {
    return {
      menu: {},
      activeMenu: [],
      activeApp: '',
      codLang: '',
      // informativa: {},
      checkInfo: false
    }
  },
  mounted: function () {
    this.codLang = sessionStorage.getItem('codLang')
    this.getMenu()
    this.loadInformativa()
  },
  methods: {
    goToArea: function (item, area) {
      let obj = {
        codiApp: area,
        area: area,
        label: item.label
      }
      this.$store.commit('set', { key: 'menu', value: obj })
      if (item.route !== undefined) {
        this.$router.push({ name: item.route })
        this.activeMenu = [this.$store.state.menu.area]
        this.activeApp = ''
        this.$emit('menuMobile')
      }
    },
    goToApp: function (item, area) {
      let obj = {
        codiApp: item.codiApp,
        area: area,
        label: item.label
      }
      this.$store.commit('set', { key: 'menu', value: obj })
      if (item.route !== undefined) {
        this.$router.push({ name: item.route })
        this.activeMenu = [this.$store.state.menu.area]
        this.activeApp = this.$store.state.menu.codiApp
        this.$emit('menuMobile')
      }
    },
    /*
    goToApp: function (appPath, area) {
      if (appPath !== undefined) {
        this.$router.push({name: appPath})
        this.setMenu()
        this.$emit('menuMobile')
      } else {
        this.activeMenu = [area]
      }
    },
    goToAppDoc: function (item, area) {
      let obj = {
        codiApp: item.codiApp,
        area: area,
        label: item.label
      }
      this.$store.commit('set', { key: 'menu', value: obj })
      if (item.route !== undefined) {
        this.$router.push({name: item.route})
        this.activeMenu = [this.$store.state.menu.area]
        this.activeApp = this.$store.state.menu.codiApp
      }
    },*/
    goToRout: function (rout) {
      this.$router.push({ name: rout })
      this.$emit('menuMobile')
    },
    getMenu: function () {
      this.$http.get('dipendente/' + this.$store.state.country + '/navMenu')
        .then(response => {
          this.$set(this, 'menu', response.body.data)
          let arrayAree = []
          for (let i = 0; i < response.body.data.length; i++) {
            let obj = {
              area: response.body.data[i].area
              // apps: response.body.data[i].apps
            }
            arrayAree.push(obj)
          }
          this.activeMenu = [this.$store.state.menu.area]
          this.activeApp = this.$store.state.menu.codiApp
        })
    },
    setMenu: function () {
      let tree = this.$route.matched
      if (tree !== undefined) {
        let area = (tree[tree.length - 1] !== undefined) ? tree[tree.length - 1].meta.area : ''
        let appName = (tree[2] !== undefined) ? tree[2].meta.appName : ''

        this.activeMenu = [area]
        this.activeApp = appName
      }
    },
    logout: function () {
      sessionStorage.setItem('token', '')
      sessionStorage.removeItem('token')
      sessionStorage.setItem('token_download', '')
      sessionStorage.removeItem('token_download')
      sessionStorage.setItem('menu', '')
      sessionStorage.removeItem('menu')
      sessionStorage.setItem('Trasferte_form', '')
      sessionStorage.removeItem('Trasferte_form')
      sessionStorage.setItem('Trasferte_Aut_form', '')
      sessionStorage.removeItem('Trasferte_Aut_form')
      sessionStorage.clear()
      this.$router.push({ name: 'Login' })
    },
    loadInformativa: function () {
      this.$set(this, 'checkInfo', false)
      // this.$set(this, 'informativa', {})
      var obj = {
        params: {
          seBlock: 'N',
          tipo: 'INF',
          order: '',
          mesi: '999'
        }
      }
      this.$http.get('communication/' + this.$store.state.country + '/messaggi', obj).then(response => {
        if (response.body.rc === 0 && response.body.data.length === 1) {
          // this.$set(this, 'informativa', response.body.data[0])
          this.$set(this, 'checkInfo', true)
        } else {
          // this.$set(this, 'informativa', {})
          this.$set(this, 'checkInfo', false)
        }
      }, response => {
        // this.$set(this, 'informativa', {})
        this.$set(this, 'checkInfo', false)
      })
    },
    getLabel: function (item) {
      let prefix = ''
      switch (item.codiArea) {
        case 'ASSENZE':
          prefix = this.$i18n.t('subMenu.ASSENZE') + ' - ';
          break;
        case 'TRASFERTE':
          prefix = this.$i18n.t('subMenu.TRASFERTE') + ' - ';
          break;
        case 'PRESENZE':
          prefix = this.$i18n.t('subMenu.PRESENZE') + ' - ';
          break;
      }
      if (item.label === undefined || item.label === null) {
        return "ERROR"
      } else {
        return prefix + item.label[this.codLang]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../assets/less/general.less";

.nav-left-mobile {
  width: 100%;
  position: fixed;
  z-index: 200;
  //width: 220px;
  top: 60px;
  bottom: 0;
  left: 0;
  //background-color: #fafafa;
  //box-shadow: inset -1px 0 0 #e5e5e5;
  //transform: translate3d(0, 0, 0);


  .el-menu {
    width: 100%;
    //border-right: 1px solid #eef4f9;
  }

  .left-bar {
    z-index: 10;
    width: 100%;

    float: left;
    background-color: @greenRiva;
    color: @white;
    text-align: center;
    //padding-top: 53px;
    padding-left: 0px !important;
    border-right: 0px;


    .el-submenu {
      .el-submenu__title {
        height: 40px;
        line-height: 38px;
        color: @white;

        //margin-top: -3px;
        .icon {
          margin-top: 5px;
          float: left;
        }

        .my-label {
          float: left;
          padding-left: 10px;
          line-height: 38px;
        }

        a:hover {
          color: @greenRiva !important;
          text-decoration: none;
        }
      }

      .el-submenu__title:hover {
        color: @greenRiva !important;
        background-color: #eef4f9;
      }

      li:first-child {
        &.is-opened {
          .el-submenu__title {
            box-shadow: 0px 0px 0px #454848, -4px 4px 5px #454848;
            -webkit-box-shadow: 0px 0px 0px #454848, -4px 4px 5px #454848;
            -moz-box-shadow: 0px 0px 0px #454848, -4px 4px 5px #454848;
            -o-box-shadow: 0px 0px 0px #454848, -4px 4px 5px #454848;
          }
        }
      }
    }


    a {
      color: @white;
    }


    // Nasconde la freccia
    .el-submenu__icon-arrow {
      display: none;
    }

    // MENU FIGLI
    .el-menu-item {
      min-width: 0px;
      max-width: 100%;
      padding-left: 0px !important;
      padding-right: 0px !important;
      padding-top: 0px !important;
      text-align: center;
      overflow: hidden;
      background-color: @greenRiva;
      color: @white;
      height: 40px;
      white-space: pre-wrap;

      .cerchio {
        margin-left: -26px;
        width: 20px;
        height: 20px;
        float: left;
      }

      .applicazione {
        float: left;
      }

      .label-menu {
        margin-top: 3px;
        height: 34px;
        width: 90%;
        word-wrap: break-word;
        border-left: 2px solid @white;
        margin-left: 20px;
        padding-left: 15px;
        .set-font(@size: 13px; @color: @white);
        vertical-align: middle;
        line-height: 34px;
        padding-top: 0px;
        text-align: left;
        //display: inline-block;
      }
    }

    .el-menu--inline {
      li.is-active {
        img {
          display: inline;
        }

        .applicazione {
          // font-weight: bold;
          .set-font(@family: 'os-semibold'; @color: @white; @size: 12px);
        }
      }

      li:not(.is-active) {
        img {
          display: none
        }

        .applicazione {
          // color: #dcd9d9 !important;
          // font-weight: normal;
          .set-font(@family: 'os-regular'; @color: #dcd9d9; @size: 12px);
        }
      }
    }


  }

  .servizi {
    z-index: 100;
    //color: @white;
    position: absolute;
    bottom: 0;
    // padding-bottom: 15px;
    width: 100%;

    //width: 55px;
    //text-align: center;
    .linea {
      width: 98%;
      height: 1px;
      background-color: @white;
      margin-left: 5px;
      margin-bottom: 0px;
    }

    .servizio {
      margin-top: 20px;
    }
  }

}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 300ms ease-in 0s
}
</style>



// WEBPACK FOOTER //
// src/components/NavLeftMobile.vue